/** @format */

import React, { FC, useState, useEffect } from 'react'
import { Table, Pagination } from 'kpc-react'

type CustomObject = { [key: string]: any }

interface TablePageProps {
  style?: any
  tableProps: CustomObject
  showPage?: boolean
  pageProps?: {
    total: number
    PageIndex?: number
    PageSize?: number
    pageIndex?: number
    pageSize?: number
    pageChange?: (PageIndex: number, PageSize: number) => void
    showLimits?: boolean
    limits?: number[]
  }
  loading?: boolean
  run?: any
}

const TablePage: FC<TablePageProps> = ({
  style,
  tableProps,
  showPage = true,
  pageProps,
  loading,
  run
}) => {
  const [totalCount, setTotalCount] = useState<number>()
  const [pageState, setPageState] = useState<{ current: number; limit: number }>({
    current: 1,
    limit: 10
  })
  useEffect(() => {
    setTotalCount(pageProps?.total || 0)
  }, [pageProps?.total])

  useEffect(() => {
    setPageState({
      current: pageProps?.PageIndex || pageProps?.pageIndex,
      limit: pageProps?.PageSize || pageProps?.pageSize
    })
  }, [pageProps?.PageIndex, pageProps?.PageSize, pageProps?.pageIndex, pageProps?.pageSize])

  const pageChange = ({ current, limit }) => {
    if (current && limit) {
      setPageState({
        current,
        limit
      })
      if (!loading) {
        run &&
          run(
            pageProps?.PageIndex
              ? {
                  PageIndex: current,
                  PageSize: limit
                }
              : {
                  pageIndex: current,
                  pageSize: limit
                }
          )
      }
    }
  }

  return (
    <div className="table-page marginTop" style={{ ...style }}>
      <Table {...tableProps}></Table>
      {showPage && (
        <Pagination total={totalCount} {...pageState} onChange={pageChange} {...pageProps} />
      )}
    </div>
  )
}

export default TablePage
